import '@vfde-brix/accordion/dist/styles.css';
import { createAccordionComponent } from '@vfde-brix/accordion';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-accordion', createAccordionComponent, NO_PATTERN_BUSINESS_LOGIC);
